// extracted by mini-css-extract-plugin
export default {"input":"input--ew9p9"};